<h2 mat-dialog-title>{{ getDialogTitle() }}</h2>
<mat-dialog-content>
<form [formGroup]="form">
    <fieldset>
        <mat-form-field appearance="outline">
            <mat-label i18n>Action type</mat-label>
            <mat-select formControlName="template" [disabled]="!isAdding" required>
                <mat-option *ngFor="let template of templates" [value]="template.type">
                    {{ template.name }}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="result">{{ result.description }}</mat-hint>
            <mat-hint *ngIf="!result" align="end" i18n>Select an action from the list ^</mat-hint>
        </mat-form-field>
    </fieldset>
    <ng-container *ngIf="shouldShowOptions">
        <fieldset>
            <fui-fieldset-legend label="Action options" i18n-label></fui-fieldset-legend>
            <p>
                <span *ngIf="!result.hasOptions" i18n>This action does not require additional configuration.</span>
            </p>

            <ng-container *ngIf="result.hasOptions">
                <ng-container [ngSwitch]="result.type">
                    <ng-container *ngSwitchCase="'send_email_to_owner'"
                                  [ngTemplateOutlet]="send_email_to_owner"
                                  [ngTemplateOutletContext]="optionsTemplateContext()">
                    </ng-container>
                    <ng-container *ngSwitchDefault
                                  [ngTemplateOutlet]="dynamic"
                                  [ngTemplateOutletContext]="optionsTemplateContext()">
                    </ng-container>
                </ng-container>
            </ng-container>
        </fieldset>
    </ng-container>
</form>
</mat-dialog-content>
<mat-dialog-actions>
    <div>
        <button *ngIf="shouldShowDelete"
                mat-button
                color="warn"
                (click)="onDelete()"
                tabindex="-1"
                i18n>Delete action</button>
    </div>
    <div>
        <button mat-button (click)="onCancel()" tabindex="-1" i18n>Discard</button>
        <button *ngIf="shouldShowSave"
                type="submit"
                mat-flat-button
                color="primary"
                (click)="onSave()"
                [disabled]="!form.valid">{{ getAddOrApply() }}</button>
    </div>
</mat-dialog-actions>

<ng-template #dynamic let-formGroup="formGroup"
                      let-result="result"
                      let-formFields="availableFormFields">
    <ng-container [formGroup]="formGroup">
        <ng-container *ngFor="let option of result.options">
            <ng-container [ngSwitch]="option.type">
                <div *ngSwitchCase="'boolean'">
                    <mat-checkbox formControlName="{{ option.id }}">{{ option.name }}</mat-checkbox>
                    <small>{{ option.description }}</small>
                </div>

                <app-workflow-transition-action-refund-options-form
                  *ngSwitchCase="'refund_options'"
                  formControlName="{{ option.id }}"
                  [isOptional]="option.isOptional">
                </app-workflow-transition-action-refund-options-form>

                <app-workflow-transition-action-fill-in-fields-form
                  *ngSwitchCase="'fill_in_fields'"
                  formControlName="{{ option.id }}"
                  [isOptional]="option.isOptional"
                  [availableFormFields]="formFields">
                </app-workflow-transition-action-fill-in-fields-form>
                <mat-form-field *ngSwitchCase="'multiSelect'" appearance="outline">
                    <mat-label>{{ option.name }}</mat-label>
                    <mat-select formControlName="{{ option.id }}" multiple>
                        <mat-option *ngFor="let value of option.categories" [value]="value.id">
                            {{ value.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngSwitchCase="'select'" appearance="outline">
                    <mat-label>{{ option.name }}</mat-label>
                    <mat-select formControlName="{{ option.id }}">
                        <mat-option *ngFor="let value of option.categories" [value]="value.id">
                            {{ value.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field *ngSwitchDefault appearance="outline">
                    <mat-label>{{ option.name }}</mat-label>
                    <input matInput formControlName="{{ option.id }}" type="{{ option.type }}">
                </mat-form-field>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #send_email_to_owner let-formGroup="formGroup">
    <ng-container [formGroup]="formGroup">
        <mat-form-field appearance="outline">
            <mat-label i18n>Subject</mat-label>
            <input matInput formControlName="subject">
        </mat-form-field>
        <label id="add-new-action-message-label" i18n>Message</label>
        <quill-editor
            class="block"
            formControlName="html"
            placeholder="Message to be sent to the recipient, can be HTML."
            [modules]="quillModules"
            i18n-placeholder
            aria-labelledby="add-new-action-message-label"></quill-editor>

        @if (formGroup.get('html').errors?.invalidPlaceholders) {
            <mat-error i18n>Invalid placeholders. Please check the formatting, and ensure any markup is applied to the whole placeholder, including percentage % wrappers.
                <ul>
                    @for (placeholder of formGroup.get('html').errors?.invalidPlaceholders?.value; track placeholder) {
                        <li>{{ placeholder }}</li>
                    }
                </ul>
            </mat-error>
        }
    </ng-container>
</ng-template>
